import React from 'react'

// Inlines an SVG (imported with Vite's `?raw`) directly into the JS bundle —
// the React analog of Rails `inline_svg`. The markup ships inside the component
// bundle, so there's no separate asset file for the server/CDN to resolve and
// no extra network request. Size it via `w-*`/`h-*` classes on the wrapper.
//
// Pass `recolor` to let the icon follow the CSS `color` (set a `text-*` class):
// its stroke/fill values are swapped for `currentColor` (the `none` keyword is
// left untouched so empty fills/strokes stay empty).
//
// Usage:
//   import iconRaw from '.../icon.svg?raw'
//   <InlineSvg svg={iconRaw} className="w-5 h-5" />
//   <InlineSvg svg={iconRaw} recolor className="w-5 h-5 text-woperty-teal" />
export default function InlineSvg({ svg, className = '', recolor = false, ...rest }) {
  const markup = recolor
    ? svg.replace(/(stroke|fill)="(?!none")[^"]*"/g, '$1="currentColor"')
    : svg

  return (
    <span
      aria-hidden="true"
      className={`inline-flex [&>svg]:w-full [&>svg]:h-full ${className}`}
      dangerouslySetInnerHTML={{ __html: markup }}
      {...rest}
    />
  )
}
